import React from 'react'
import { Flex, Span, Grid, Input, Label } from '@fareye/ui'
import { isEmpty, getExceptionType } from '@fareye/utils'
import { displayTime } from '../../../utility/function'
import { tripTabsBackground } from '@fareye/configs'
import { useTranslation } from '@fareye/common'
const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    padding: '12px',
    minHeight: '95%',
    overflowY: 'auto'
  }
}
export const Exceptions = ({ otherData, selectedId, onSelect }: any) => {
  const { exceptions } = otherData
  const { t } = useTranslation()
  return (
    <Flex column style={style.tripTabs}>
      <Span style={{ fontSize: '14px', fontWeight: 600 }}>
        {t('Exceptions')}
      </Span>
      {!isEmpty(exceptions) && (
        <Grid
          gridTemplateColumns={'1fr 3fr 2fr 2fr'}
          style={{
            margin: '12px 0px 4px '
          }}
        >
          <Span></Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {t('Type')}
          </Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {t('Created At')}
          </Span>
          <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
            {t('Status')}
          </Span>
        </Grid>
      )}
      {!isEmpty(exceptions) ? (
        exceptions.map((item: any, index: number) => (
          <Grid
            gridTemplateColumns={'1fr 3fr 2fr 2fr'}
            style={{
              margin: '12px 0px 4px '
            }}
            key={`exceptions${index}`}
          >
            <Input
              type="radio"
              checked={item.id === selectedId.exception}
              onChange={() => {
                onSelect({ exception: item.id })
              }}
            />
            <Flex column>
              <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
                {item.type && t(getExceptionType(item.type))}
              </Span>
              <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
                {item.alertType ? `(${t(item.alertType)})` : null}
              </Span>
            </Flex>
            <Flex column>
              <Span>{displayTime(item.createdAt, 'hhmma')}</Span>
              <Span>{displayTime(item.createdAt, 'ddMMMMYYYY')}</Span>
            </Flex>
            <Flex column>
              {item.isClosed && (
                <Span variant={'secondary'}>{t('Resolved')}</Span>
              )}
            </Flex>
          </Grid>
        ))
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
